import { render, staticRenderFns } from "./TransferJigPromptYesNo.vue?vue&type=template&id=4a6869e0"
import script from "./TransferJigPromptYesNo.vue?vue&type=script&lang=ts"
export * from "./TransferJigPromptYesNo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports